import React, { useState, useEffect, useMemo } from 'react';
import { Button, Row, Col, Table, Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loading } from '@rd-web-markets/shared/dist/util';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import claimEmployeeRndApportionmentsService from '../../services/claim/claim_employee_rnd_apportionments.service';
import claimEmployeesService from '../../services/claim/claim_employees.service';
import { helpPages } from './Help';
import TeachingBubble from '@rd-web-markets/shared/dist/util/TeachingBubble';
import { EmployeeActivityRow, EmployeeActivityRowHeader, EmployeeActivityTotalsRow } from './';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import NotesList from '@rd-web-markets/shared/dist/financialSection/NotesList';
export const EmployeesActivitySection = _ref => {
  let {
    accountType,
    claim,
    refreshClaim,
    setClaim,
    allProjects
  } = _ref;
  const [claimEmployees, setClaimEmployees] = useState(null);
  const [headerScrollPosition, setHeaderScrollPosition] = useState(0);
  const dispatch = useDispatch();
  const claimId = useMemo(() => claim === null || claim === void 0 ? void 0 : claim.id, [claim]);
  const [isShowInvolvement, setIsShowInvolvement] = useState(false);
  useEffect(() => {
    async function getData() {
      try {
        if (claimId) {
          setClaimEmployees(await claimEmployeesService.all(claimId));
        }
      } catch (error) {
        dispatch(handleError(error));
      }
    }
    setIsShowInvolvement(claim.claim_group.cost_methodology === 'consolidated');
    getData();
  }, [dispatch, claimId]);
  const sortedClaimProjectReports = useMemo(() => {
    if (!allProjects) return [];
    return allProjects.sort((a, b) => {
      if (a.project_name < b.project_name) {
        return -1;
      }
      if (a.project_name > b.project_name) {
        return 1;
      }
      return 0;
    });
  }, [allProjects]);
  if (!claim || !claimEmployees) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-end"
  }, /*#__PURE__*/React.createElement(TeachingBubble, {
    pages: helpPages,
    position: "left"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pb-5"
  }), /*#__PURE__*/React.createElement(Table, {
    size: "md"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(EmployeeActivityRowHeader, {
    claim: claim,
    sortedClaimProjectReports: sortedClaimProjectReports,
    setHeaderScrollPosition: setHeaderScrollPosition,
    isShowInvolvement: isShowInvolvement
  })), /*#__PURE__*/React.createElement("tbody", null, claimEmployees.map((_, index) => {
    return /*#__PURE__*/React.createElement(EmployeeActivityRow, {
      key: index,
      index: index,
      claim: claim,
      sortedClaimProjectReports: sortedClaimProjectReports,
      headerScrollPosition: headerScrollPosition,
      refreshClaim: refreshClaim,
      claimEmployees: claimEmployees,
      setClaimEmployees: setClaimEmployees,
      claimEmployeesService: claimEmployeesService,
      handleError: handleError,
      claimEmployeeRndApportionmentsService: claimEmployeeRndApportionmentsService,
      isShowInvolvement: isShowInvolvement
    });
  }), /*#__PURE__*/React.createElement(EmployeeActivityTotalsRow, {
    claim: claim,
    isShowInvolvement: isShowInvolvement
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "outline-primary",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/employees_bio")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back")), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/staffing_costs")
  }, "Continue ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right")))));
};